<script lang="ts" module>
  import { TeoCore } from '@/teoCore/TeoCore';
  import Loading from '@/ui/base/icon/specials/Loading.svelte';
  import { tv } from '@/ui/tv';

  export interface VersionScoreProps {
    value: number | null;
    class?: string;
    loading?: boolean;
  }

  const styles = tv({
    base: 'inline-flex min-h-7 min-w-18 items-center justify-center whitespace-nowrap rounded-sm px-2 text-sm font-semibold leading-none text-c-base',
    variants: {
      status: {
        good: 'bg-success',
        warn: 'bg-warning',
        bad: 'bg-error',
        loading: 'bg-info',
      },
    },
  });
</script>

<script lang="ts">
  let { value, class: className, loading }: VersionScoreProps = $props();
  let cn = $derived(getClass(value, loading, className));

  function getStatus(value: number) {
    if (value >= TeoCore.current.staticConfig.tpiTarget) return 'good';
    if (value > 50) return 'warn';
    return 'bad';
  }

  function getClass(value: number | null, loading: boolean | undefined, className?: string) {
    if (loading) return styles({ status: 'loading', className });
    if (value === null) return '';
    return styles({ status: getStatus(value), className });
  }
</script>

{#if value !== null}
  <div class={cn}>
    {#if loading}
      <div class="flex items-center justify-center p-1">
        <Loading class="text-c-bullet-S" size={4} />
      </div>
    {:else}
      TPI: {Math.floor(value)}
    {/if}
  </div>
{/if}
